/* eslint-disable max-len */
export const convertEpochToDateFormat = (timestamp,format) => {

    if(timestamp==0){
        return '-';
    }
    //'MM/DD/YYYY,AM/PM','MM/DD/YYYY','DD/MM/YYYY,AM/PM','DD/MM/YYYY'

    const date = new Date(timestamp* 1000) ; // Multiply by 1000 for milliseconds
    let formattedDate='';
    const formattedDateDDMMYYYY = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;

    // Format the date as mm-dd-yyyy
    const formattedDateMMDDYYYY = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

    if(format==="DD-MM-YYYY"){
        return formattedDateDDMMYYYY
    }
    switch (format) {
    case 'DD/MM/YYYY, 24hrs, Leading zeros':
     
        formattedDate = date.toLocaleString('en-GB', {
            day: '2-digit',
            year: 'numeric',
            month: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        });  
        break;
    
    case 'DD/MM/YYYY, 24hrs, No leading zeros':
       
        const day = date.getDate()
        const month = (date.getMonth() + 1)
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes().toString().padStart(2, '0');
        const second = date.getSeconds().toString().padStart(2, '0');
      
        formattedDate=`${day}/${month}/${year} ${hour}:${minute}:${second}`;
      
        break;
        
    case 'MM/DD/YYYY, 24hrs, No leading zeros':
     
        // formattedDate = date.toLocaleString('en-US', {
        //     month: 'numeric',
        //     day: 'numeric',
        //     year: 'numeric',
        //     hour: 'numeric',
        //     minute: '2-digit',
        //     second: '2-digit',
        //     hour12: false,
        // });
        const daymm = date.getDate()
        const monthmm = (date.getMonth() + 1)
        const yearmm = date.getFullYear();
        const hourmm = date.getHours();
        const minutemm = date.getMinutes().toString().padStart(2, '0');
        const secondmm = date.getSeconds().toString().padStart(2, '0');
        formattedDate=`${monthmm}/${daymm}/${yearmm} ${hourmm}:${minutemm}:${secondmm}`;
        break;

    case 'MM/DD/YYYY, AM/PM, No leading zeros':
        formattedDate = date.toLocaleString('en-US', {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        });
                    
        break;
    case 'MM/DD/YYYY, 24hrs, Leading zeros':
     
        formattedDate = date.toLocaleString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        });
        break;

    case 'DD/MM/YYYY, AM/PM, Leading zeros':
        // formattedDate = date.toLocaleString('en-GB', {
        //     day: '2-digit',
        //     year: 'numeric', 
        //     month: '2-digit',    
        //     hour: '2-digit',
        //     minute: '2-digit',
        //     second: '2-digit',
        //     hour12: true,
        // });
        const daydd = date.getDate().toString().padStart(2, '0');
        const monthdd = (date.getMonth() + 1).toString().padStart(2, '0');
        const yeardd= date.getFullYear();
        const hourdd = date.getHours()
        const hoursdd = hourdd % 12 || 12; // Convert to 12-hour format
        const amPmdd = hourdd >= 12 ? 'PM' : 'AM'; // Determine AM/PM
        const minutedd = date.getMinutes().toString().padStart(2, '0');
        const seconddd = date.getSeconds().toString().padStart(2, '0');
      
        formattedDate=`${daydd}/${monthdd}/${yeardd} ${hoursdd.toString().padStart(2, '0')}:${minutedd}:${seconddd} ${amPmdd}`;
        break;
    case 'DD/MM/YYYY, AM/PM, No leading zeros':
      
        const day2 = date.getDate()
        const month2 = (date.getMonth() + 1)
        const year2= date.getFullYear();
        const hour2 = date.getHours();
        const hours12 = hour2 % 12 || 12; // Convert to 12-hour format
        const amPm = hour2 >= 12 ? 'PM' : 'AM'; // Determine AM/PM
        const minute2 = date.getMinutes().toString().padStart(2, '0');
        const second2 = date.getSeconds().toString().padStart(2, '0');
      
        formattedDate=`${day2}/${month2}/${year2} ${hours12}:${minute2}:${second2} ${amPm}`;
        break;

    

    case 'MM/DD/YYYY, AM/PM, Leading zeros':
        formattedDate = date.toLocaleString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        });
        
        break;
    
    
   

    
    
    default:
        formattedDate=`${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    }

    return formattedDate;
};

